<template>
  <div class="Inspection4">
    <h1 id="heading">Bewertung der Fahrzeugbedingungen</h1>
    <v-divider></v-divider>
    <div v-if="isLitzenSeil" class="justify-center">
      <div class="text-xs-center">
        <h3>Welche der 2 Optionen trifft auf das Seil zu?</h3>
      </div>
      <v-container>
        <v-layout>
          <v-flex xs12 sm6>
            <!-- <v-radio-group>
              <v-radio label="Gespleißte Seilschleife oder feste Enden ohne Klemmen" value="1"></v-radio>
            </v-radio-group> -->
            <v-btn
              @click="case1"
              color="blue"
              class="caseBtn"
              style="color: white"
              large
            ><span style="font-size: 100%;">Gespleißte Seilschleife oder<br>feste Enden ohne Klemmen</span></v-btn>
            <p style="border: 1px solid black">Relative Bewertung: 0</p>

            <v-spacer></v-spacer>
            <v-divider></v-divider>
            <div
              style="border: 1px solid black; box-shadow: 2px 2px 0px 0px #989797; margin-right: 5%; margin-top: 5%;"
            >
              <h3 class="headline green lighten-1">
                <span style="color: white; font-size: 70%;"> z.B. oberes Zugseil einer Standseilbahn</span>
              </h3>
              <v-img
                :src="require('@/statics/images/Standseilbahn.jpg')"
                style="height: 300px; width: 50%; margin: 10%; margin-left: auto; margin-right: auto; display: block;"
              ></v-img>
            </div>
            <div
              style="border: 1px solid black; box-shadow: 2px 2px 0px 0px #989797; margin-right: 5%; margin-top: 5%;  "
            >
              <h3 class="headline green lighten-1">
                <span style="color: white;  font-size: 70%;">z.B. Seilende mit Vergusskegel</span>
              </h3>
              <v-img
                :src="require('@/statics/images/Vergusskegel2.png')"
                style="height: 300px; width: 50%; margin: 10%; margin-left: auto; margin-right: auto; display: block;"
              ></v-img>
            </div>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs12 sm6>
            <!-- <v-radio-group style="margin-left:3%">
              <v-radio label="Gespleißte Seilschleife mit kuppelbaren oder festen Klemmen" value="1" @change="buttonChanged()"></v-radio>
            </v-radio-group> -->
            <v-btn
              @click="case2"
              color="blue"
              class="caseBtn"
              style="color: white"
              large
            ><span style="font-size: 100%">Gespleißte Seilschleife mit<br>kuppelbaren oder festen Klemmen</span></v-btn>
            <p style="border: 1px solid black">Relative Bewertung: 1</p>

            <v-spacer></v-spacer>
            <v-divider></v-divider>
            <div
              style="border: 1px solid black; box-shadow: 2px 2px 0px 0px #989797; margin-left: 5%; margin-top: 5%;"
            >
              <h3 class="headline green lighten-1">
                <span style="color: white;  font-size: 70%;">z.B. kuppelbare Seilklemme</span>
              </h3>
              <v-img
                :src="require('@/statics/images/Patscherkofl2.jpg')"
                style="height: 300px; width: 50%; margin: 10%; margin-left: auto; margin-right: auto; display: block;"
              ></v-img>
            </div>

            <div
              style="border: 1px solid black; box-shadow: 2px 2px 0px 0px #989797; margin-left: 5%; margin-top: 5%;"
            >
              <h3 class="headline green lighten-1">
                <span style="color: white;  font-size: 70%;">z.B. feste Seilklemme</span>
              </h3>
              <v-img
                :src="require('@/statics/images/fixe_Klemme.jpg')" 
                style="height: 300px; width: 50%; margin: 10%; margin-left: auto; margin-right: auto; display: block;"
              ></v-img>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-if="isVollverschlossen">
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="name"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.assess }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.assess"
                :value="props.item.assess"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      
      <div class="description">
        <v-dialog v-model="dialog4" max-width="500px" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="green" slot="activator" x-small fab v-on="on">
              <v-icon color="white" small>fas fa-info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="green" height="50px">
              <v-toolbar-title style="color: white; font-size: 150%">Fahrzeugbedingungen</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn @click="close4" small icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text style="font-size: 100%;">
              <p>
               Bitte Hersteller kontaktieren
              </p>
              <br>
              <p style="text-decoration: underline;"></p>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection4",
  props: ["assessmen"],
  data() {
    return {
      assessment: 0,
      assessName: "",
      assessHeader: "",
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      isLitzenSeil: false,
      isVollverschlossen: false,
      items: [
        {
          name:
            "Fahrzeugrollen mit weicher Einlage, Elastizitätsmodul kleiner oder gleich 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge unter 10 kN",
          assess: 0
        },
        {
          name:
            "Fahrzeugrollen mit harter Einlage, Elastizitätsmodul größer 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge 10 kN bis 20 kN",
          assess: 1
        },
        {
          name:
            "Fahrzeugrollen mit harter Einlage, Elastizitätsmodul größer 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge 20 kN bis 30 kN",
          assess: 2
        },
        {
          name:
            "Fahrzeugrollen mit harter Einlage, Elastizitätsmodul größer 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge größer 30 kN",
          assess: 3
        }
      ],
      headers: [
        {
          text:
            "Vollverschlossene Seile, max. Querlast der Rollen auf die freie Seillänge",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, value: "assess" }
      ]
    };
  },
  methods: {
    buttonChanged(event){
      console.log(event);
    },
    setLocked() {
      this.isLocked = true;
      this.question = true;
    },
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName =
            "Fahrzeugrollen mit weicher Einlage, Elastizitätsmodul kleiner oder gleich 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge unter 10 kN";
          break;
        case 1:
          this.assessName =
            "Fahrzeugrollen mit harter Einlage, Elastizitätsmodul größer 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge 10 kN bis 20 kN";
          break;
        case 2:
          this.assessName =
            "Fahrzeugrollen mit harter Einlage, Elastizitätsmodul größer 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge 20 kN bis 30 kN";
          break;
        case 3:
          this.assessName =
            "Fahrzeugrollen mit harter Einlage, Elastizitätsmodul größer 5000 N/mm², max. Querlast der Rollen auf die freie Seillänge größer 30 kN";
          break;
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Fahrzeugbedingungen";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    case2() {
      this.assessment = 1;
      this.progressFurther();
    },
    case1() {
      this.assessment = 0;
      this.progressFurther();
    },
    progressFurther(){
      switch (this.assessment) {
        case 0:
          this.assessName =
            "Gespleißte Seilschleife oder feste Enden ohne Klemmen";
          break;
        case 1:
          this.assessName =
            "Gespleißte Seilschleife mit kuppelbaren oder festen Klemmen";
          break;
        
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Fahrzeugbedingungen";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    close1() {
      this.dialog1 = false;
    },
    close2() {
      this.dialog2 = false;
    },
    close3() {
      this.dialog3 = false;
    },
    close4(){
      this.dialog4 = false;
    }
  },
  created() {
    var ropeType = this.$store.state.facilityList.find(x => x.id == this.$store.state.inspectingFacilityID).ropeList.find(x => x.id == this.$store.state.inspectingRopeID).rope;
    if (ropeType.includes("Litzenseil")) {
      this.assessment = 0;
      this.isLitzenSeil = true;
    } else {
      this.isVollverschlossen = true;
    }
  }
};
</script>

<style>
.Inspection4 {
  background-color: white;
  width: 95%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}

.description {
  padding-top: 3%;
  text-align: center;
  padding-left: 10%;
  padding-right: 10%;
}

.caseBtn {
  color: white;
  font-size: 110%;
}
</style>
